import { handleChunkLoadError } from '@hydra/utils/handleChunkLoadError';

export default ({
  path: 'pages/:url',
  async getComponent (nextState) {
    const {
      default: PagesContainer
    } = await import(/* webpackChunkName: "pages-container" */ './components/PagesContainer.jsx')
      .catch(handleChunkLoadError);
    return PagesContainer;
  },
  getData: ({ context: { props } }) => props || {},
  children: [
    {
      path: '',
      async getComponent (nextState) {
        const {
          default: Pages
        } = await import(/* webpackChunkName: "pages" */ './components/Pages')
          .catch(handleChunkLoadError);
        return Pages;
      },
      getData ({ context: { props } }) {
        return props;
      }
    }
  ]
});
